import { render, staticRenderFns } from "./ComponentVulnerabilities.vue?vue&type=template&id=90bdf8a6&"
import script from "./ComponentVulnerabilities.vue?vue&type=script&lang=js&"
export * from "./ComponentVulnerabilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports